import React, { ReactNode } from 'react';
import { Menu } from 'antd';
import './Toolbar.less';

export type ToolbarProps = {
  items?: {
    key: string;
    icon?: ReactNode;
    content?: ReactNode;
    subMenu?: Array<{
      key: string;
      content: ReactNode;
    }>;
  }[];
  onClick: any;
  mode?: 'horizontal' | 'vertical' | 'inline';
};

const TToolbar: React.FC<ToolbarProps> = ({
  items,
  mode = 'vertical',
  onClick,
}) => {
  return (
    <div className={`t-toolbar t-toolbar-${mode}`}>
      {items.map((item, index) => {
        let children = null;
        if (item.subMenu) {
          children = item.subMenu.map((child) => {
            return <Menu.Item key={child.key}>{child.content}</Menu.Item>;
          });
          children = (
            <Menu.SubMenu
              className="t-submenu"
              key={item.key}
              icon={item.icon}
              title={item.content}
              popupClassName="t-toolbar-popup-item"
            >
              {children}
            </Menu.SubMenu>
          );
        } else {
          children = (
            <Menu.Item key={item.key} icon={item.icon}>
              {item.content}
            </Menu.Item>
          );
        }
        return (
          <Menu
            key={`menu-${index}`}
            mode={mode}
            onClick={onClick}
            selectable={false}
          >
            {children}
          </Menu>
        );
      })}
    </div>
  );
};

export default TToolbar;
